import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ProfileChange = gql`
  mutation ProfileChange($input: ProfileChangeInput!) {
    profileChange(input: $input) {
      ... on ProfileChangeDeclined {
        __typename
        declineMessage
      }
      ... on ProfileChangeError {
        __typename
        ...error
      }
      ... on ProfileChangeSuccess {
        __typename
        challengeContext
        challengeId
        challengeState
        challengeType
        updated
      }
    }
  }
  ${error}
`;
export default ProfileChange;
